var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleClick()}}},[_vm._t("default",function(){return [_vm._v("Logout")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }